// features/candidates/reducers.js
import {
  FETCH_CANDIDATES_REQUEST,
  FETCH_CANDIDATES_SUCCESS,
  FETCH_CANDIDATES_FAILURE,
  ADVANCE_SEARCH_REQUEST,
  ADVANCE_SEARCH_SUCCESS,
  ADVANCE_SEARCH_FAILURE,
  REMOVE_CANDIDATE_FROM_LIST
} from './candidateAction'

const initialState = {
  candidates: [], // Holds all candidates or search results
  loading: false,
  error: null
}

const candidatesReducer = (statee = initialState, action) => {
  switch (action.type) {
    case FETCH_CANDIDATES_REQUEST:
    case ADVANCE_SEARCH_REQUEST:
      return {
        ...statee,
        loading: true,
        error: null
      }
    case FETCH_CANDIDATES_SUCCESS:
      return {
        ...statee,
        loading: false,
        candidates: action.payload
      }
    case ADVANCE_SEARCH_SUCCESS:
      return {
        ...statee,
        loading: false,
        candidates:
          action.payload.page > 1
            ? {
                ...action.payload.results,
                products: (statee.candidates.products || []).concat(
                  action.payload.results.products || []
                )
              }
            : action.payload.results
      }
    case FETCH_CANDIDATES_FAILURE:
    case ADVANCE_SEARCH_FAILURE:
      return {
        ...statee,
        loading: false,
        error: action.payload
      }
    case REMOVE_CANDIDATE_FROM_LIST:
      if (!statee.candidates || !statee.candidates.products) {
        return statee
      }
      return {
        ...statee,
        candidates: {
          ...statee.candidates,
          products: statee.candidates.products.filter(
            c => c.id !== action.payload
          )
        }
      }
    default:
      return statee
  }
}

export default candidatesReducer
